<div [ngStyle]="{'height': height + 'px'}">
    &nbsp;
</div>
